import DisplayHeader from 'scoreboard/components/display-header'
import File from 'scoreboard/components/files/file'
import GenericOverviewInfo from 'scoreboard/components/overview-info/generic-overview-info'
import appDisplay from 'scoreboard/components/app-display'

const DocumentsDisplayHeader = DisplayHeader.extend({

	overviewInfo: function() {
		var file = new File({ id: this.model.id })
		appDisplay.dialog(file.fetch({
			data: {
				relatedItems: true
			}
		}), () => new GenericOverviewInfo({ model: file }))
	}

})

export default DocumentsDisplayHeader

DocumentsDisplayHeader.__filename__ = 'documents/documents-display-header.js'
